angular
    .module('rangeComponent.componets', [])
    .component('rangeComponent', {
        templateUrl: 'ng/components/rangeComponent/rangeComponent.view.html',
        bindings: {
            min: '<',
            max: '<',
            step: '<',
            selectedValue: '<',
            containerClass: '@',
            name: '@',
            onChange: '&',
            allRate: '<'
        },
        controllerAs: 'rangeComponentCtrl',
        controller: function rangeComponentCtrl($rootScope) {

            var self = this;
            self.array = [];
            self.$onInit = function () {
                self.levelvalue = self.selectedValue;
                var x = self.min;
                var y = self.max;
                var z = self.step;
                if (self.step != 0) {
                    self.indexId = Math.floor(1 + Math.random() * 100);
                    self.temp = Math.floor(100 / ((self.max / self.step) + 2));
                    console.log(self.allRate);
                    while (x <= y) {
                        var temp = self.allRate && self.allRate.find(function (elem) {

                            return elem.month == x;

                        });
                        if (typeof temp === 'undefined') {
                            self.array.push({
                                value: x,
                                visible: false
                            });
                        } else {
                            self.array.push({
                                value: x,
                                visible: true
                            });
                        }
                        x = x + z;
                    }

                    self.margin = Math.ceil((100 - (2 * self.temp)) / (self.array.length - 2));
                }
                self.checkBrowser();
            }
            self.changeValue = function (item) {

                var temp = self.allRate.find(function (elem) {

                    return elem.month == item;

                });

                if (typeof temp === 'undefined') {

                    item += 6;
                    self.levelvalue = item;



                }

                self.onChange({
                    value: item
                })
            }

            self.checkBrowser = function () {
                var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

                if (isIEOrEdge) {
                    $('#forIex').css({
                        'top': '0'
                    });

                    $('#ieDetected').addClass('ie10');
                }


            };
        }
    });